import {useEffect, useState, useMemo, useRef} from 'react'
import {useUserFeatures} from '../../../../context/user-features-context'
import {applyProductRulesBeforeLoading} from '../../../../features/CatalogGrid/utils/productPreloadRules'
import {useDispatch, useSelector} from 'react-redux'
import {useAuth0} from '@auth0/auth0-react'
import {useLocation} from 'react-router'
import {useAuthClient} from '../../../../utils/use-auth-client'
import {useAsync} from '../../../../utils/use-async'
import {KP11LinkUseCoupons} from './kp11-use-coupons'
import {kP11LinkService} from './kp11-service'
import {toast} from 'react-toastify'
import {countryCurrencyEnum} from './kp11-utility'
import {
  initializeKP11Cart,
  setThryvSubscriptionData,
  resetToDefaultCart,
  setKeapTextVoiceQuantity,
  setKeapAddContactsQuantity,
  setKeapAddUsersQuantity,
  setSelectedKeapTextVoiceOption,
  setSelectedKeapAddContactsOption,
  setSocialAdsBronzeQuantity,
  setSocialAdsSilverQuantity,
  setSocialAdsGoldQuantity,
  setAlphaSEOFromRecurly,
  setAlphaKeyCount,
  setAlphaPowerBoostCount,
} from '../../../../app-store/kp11CartSlice'
import {filterCentersAndAppsByCountry} from './kp11-country-filter'
import {selectedLinkType} from '../../../../app-store/kpGlobalStateSlice'
import {
  KEAP_ADDONS_PARENT_CODES,
  MC_2_0_PLANS,
} from '../../../../utils/constants'
import {
  selectEffectiveRole,
  // selectUserRoles,
} from '../../../../app-store/selector'
// import {getUserRoles} from '../../../../utils/get-user-roles'

const buildCenterAndAppsGroups = (
  centersAndApps,
  context,
  restrictedCodes = ['rc-5-thryv-m2m'],
  restrictedEnts = [],
  targetCurrency = 'USD',
  mcFlagEnabled = false,
) => {
  const defaultEmailValidationCard = {
    title: 'Validate Email',
    key: 'validateEmail',
    items: [],
    requires: [],
    type: 'single',
    section: 'validation',
    disabled: false,
  }

  const onetimeFeesCard = {
    title: 'oneTimeFees',
    key: 'oneTimeFees',
    items: [],
    requires: [],
    type: 'single',
    section: 'oneTimeFees',
    disabled: false,
  }

  // Merge centers + apps + oneTimeFees for universal filtering
  const centers = centersAndApps.centers || []
  const apps = centersAndApps.apps || []
  const oneTimeFees = centersAndApps.oneTimeFees || []
  const combinedList = [...centers, ...apps, ...oneTimeFees]

  const filterByName = keyword =>
    combinedList
      .filter(
        i =>
          i.name.toLowerCase().includes(keyword.toLowerCase()) &&
          !restrictedCodes.includes(i.code) &&
          i?.uigroup != null &&
          i?.uigroup?.toLowerCase() !== 'hidden',
      )
      .map(i => ({
        ...i,
        entitlements:
          i.entitlements?.filter(ent => !restrictedEnts.includes(ent.name)) ||
          // .map(ent => ({
          //   ...ent,
          //   name:
          //     ent.code === 'ent-5-website'
          //       ? 'Thryv Professionally Designed Website'
          //       : ent.name,
          // }))
          [],
      }))

  // Now all filters check both centers & apps
  const marketingCenters = filterByName('marketing center')
  const seo = filterByName('aeo & seo')
  const thryvLeads = filterByName('thryv leads')
  const growthPackages = filterByName('growth package')
  const thryvAddons = filterByName('thryv add-ons')
  const workforceCenters = filterByName('workforce center')
  const keapAddons = filterByName('keap add-ons')
  const businessCenters = filterByName('business center')
  // if (context === 'catalog') {
  //   combinedList.push(...socialAdsFromConstTemp) //----> get this from v3list
  // }
  const socialAds = filterByName('social ads')

  let thryvAddOnsG = []
  let growthPackagesG = []
  let socialAdsG = []

  if (context === 'catalog') {
    thryvAddOnsG = thryvAddons
  } else if (context === 'cart') {
    // Find app market item
    const appMarketThryvAddon = thryvAddons.find(
      item => item.code === 'appmarket-5-thryv-m2m',
    )

    thryvAddOnsG = thryvAddons
      .map(item => {
        if (item.code === 'appmarket-5-thryv-m2m') {
          const allowedAddons = [
            'addon-5-signatures_usage',
            'app-websitebuilder',
          ]
          return {
            ...item,
            addons:
              item.addons?.filter(addon =>
                allowedAddons.some(key => addon.code?.includes(key)),
              ) || [],
          }
        }
        return item
      })
      .filter(Boolean)

    // Filter only the growth package addons
    const allowedGrowthAddons = ['addon-5-mcstartgr', 'addon-5-mcexpangr']
    growthPackagesG =
      appMarketThryvAddon?.addons?.filter(addon => {
        const hasAllowedCode = allowedGrowthAddons.some(key =>
          addon.code?.includes(key),
        )
        // Also check if addon has the selected country's currency
        // const hasCurrency =
        //   Array.isArray(addon.currencies) &&
        //   addon.currencies.some(c => c.currency === targetCurrency)
        // return hasAllowedCode && hasCurrency
        return hasAllowedCode
      }) || []
    // Filter only the social Ads addons
    const allowedSocialAds = [
      'addon-socialadsbronze-5-m2m',
      'addon-socialadssilver-5-m2m',
      'addon-socialadsgold-5-m2m',
    ]
    socialAdsG =
      appMarketThryvAddon?.addons?.filter(addon => {
        const hasAllowedCode = allowedSocialAds.some(key =>
          addon.code?.includes(key),
        )
        // Also check if addon has the selected country's currency
        // const hasCurrency =
        //   Array.isArray(addon.currencies) &&
        //   addon.currencies.some(c => c.currency === targetCurrency)
        // return hasAllowedCode && hasCurrency
        return hasAllowedCode
      }) || []
  }

  // let seoG = []
  // if (context === 'catalog') {
  //   seoG = seo.map(item => {
  //     if (item.code === 'seobase-5-thryv-m2m') {
  //       return {
  //         ...item,
  //         entitlements: [...seoAddonList],
  //       }
  //     } else {
  //       return item
  //     }
  //   })
  // } else if (context === 'cart') {
  //   seoG = seo
  // }

  // Thryv Growth Platform: MC 2.0 plans, gated by mcFlagEnabled
  const mc2Items = mcFlagEnabled
    ? combinedList.filter(
        i =>
          MC_2_0_PLANS.includes(i.code) &&
          i?.uigroup?.toLowerCase() !== 'hidden',
      )
    : []

  // Other centers and apps (both combined)
  const otherItems = combinedList.filter(
    i =>
      !i.name.toLowerCase().includes('marketing center') &&
      !i.name.toLowerCase().includes('seo') &&
      !i.name.toLowerCase().includes('thryv leads') &&
      !i.name.toLowerCase().includes('thryv add-ons') &&
      !i.name.toLowerCase().includes('growth package') &&
      !i.name.toLowerCase().includes('social ads') &&
      !i.name.toLowerCase().includes('workforce') &&
      !i.name.toLowerCase().includes('keap add-ons') &&
      !i.name.toLowerCase().includes('business center') &&
      !MC_2_0_PLANS.includes(i.code) &&
      (context === 'catalog' ? !restrictedCodes.includes(i.code) : true),
  )

  // Helper to extract requires from product data
  const extractRequires = items => {
    if (!items || !items.length) return []

    const requiresSet = new Set()
    items.forEach(item => {
      const normalizedRequires =
        item?.requires?.length > 0 ? item.requires : item?.requiresCenter || []

      // Check requires (canonical: `requires`; legacy fallback: `requiresCenter`)
      if (Array.isArray(normalizedRequires) && normalizedRequires.length > 0) {
        normalizedRequires.forEach(code => {
          if (typeof code !== 'string') return
          // Map code to group key
          if (code.includes('mc_')) {
            requiresSet.add('marketingCenter')
          } else if (code.includes('wc_')) {
            requiresSet.add('workforceCenter')
          } else if (code.includes('keap_')) {
            requiresSet.add('KeapMax')
          } else if (code.includes('bc_')) {
            requiresSet.add('businessCenter')
          } else if (code.includes('appmarket')) {
            requiresSet.add('thryvAddons')
          }
        })
      }
      // Check requiresAddon
      if (
        !(item?.requires?.length > 0) &&
        Array.isArray(item?.requiresAddon) &&
        item.requiresAddon.length > 0
      ) {
        item.requiresAddon.forEach(code => {
          // Map addon codes to group keys if needed
          if (typeof code === 'string' && code.includes('appmarket')) {
            requiresSet.add('thryvAddons')
          }
        })
      }
    })

    return Array.from(requiresSet).map(group => ({group}))
  }

  // Helper to merge hardcoded dependency with extracted requires
  const mergeRequires = (groupKey, extractedRequires) => {
    const requiresSet = new Set()

    // Add the hardcoded group key
    if (groupKey) {
      requiresSet.add(groupKey)
    }

    // Add all extracted requires
    extractedRequires.forEach(req => {
      if (req.group) {
        requiresSet.add(req.group)
      }
    })

    return Array.from(requiresSet).map(group => ({group}))
  }

  const dynamicGroups = []

  if (marketingCenters.length) {
    dynamicGroups.push({
      title: 'Thryv Marketing Center',
      key: 'marketingCenter',
      items: marketingCenters,
      requires: extractRequires(marketingCenters),
      type: 'group',
      section: 'centers',
      subGroup: null,
    })
  }
  if (workforceCenters.length) {
    dynamicGroups.push({
      title: 'Workforce Center',
      key: 'workforceCenter',
      items: workforceCenters,
      requires: extractRequires(workforceCenters),
      type: 'group',
      section: 'centers',
      subGroup: null,
    })
  }
  if (businessCenters.length) {
    dynamicGroups.push({
      title: 'Thryv Business Center',
      key: 'businessCenter',
      items: businessCenters,
      requires: extractRequires(businessCenters),
      type: 'group',
      section: 'centers',
      subGroup: null,
    })
  }

  if (keapAddons && keapAddons.length > 0) {
    dynamicGroups.push({
      title: 'Keap Addons',
      key: 'keapAddons',
      items: keapAddons,
      requires: extractRequires(keapAddons),
      type: 'group',
      section: 'apps',
      mutuallyExclusiveWith: [],
      subGroup: null,
    })
  }

  if (seo.length) {
    dynamicGroups.push({
      title: 'AEO & SEO',
      key: 'aeo & seo',
      items: seo,
      // items: seoG,
      requires: mergeRequires('marketingCenter', extractRequires(seo)),
      type: 'group',
      section: 'apps',
      mutuallyExclusiveWith: [],
      subGroup: 'aeo & seo',
    })
  }

  if (thryvLeads.length) {
    dynamicGroups.push({
      title: 'Thryv Leads',
      key: 'thryvLeads',
      items: thryvLeads,
      requires: mergeRequires('marketingCenter', extractRequires(thryvLeads)),
      type: 'group',
      section: 'apps',
      mutuallyExclusiveWith: ['thryvAddons'],
    })
  }

  if (thryvAddOnsG.length) {
    dynamicGroups.push({
      title: 'Thryv Addons',
      key: 'thryvAddons',
      items: thryvAddOnsG,
      requires: extractRequires(thryvAddOnsG),
      type: 'group',
      section: 'apps',
      mutuallyExclusiveWith: [],
      subGroup: null,
    })
  }
  if (growthPackages.length || growthPackagesG.length) {
    dynamicGroups.push({
      title: 'Thryv Growth Package',
      key: 'thryvGrowthPackage',
      items: [...growthPackages, ...growthPackagesG],
      requires: extractRequires([...growthPackages, ...growthPackagesG]),
      type: 'group',
      section: 'apps',
      mutuallyExclusiveWith: [],
      subGroup: 'growthPackage',
    })
  }
  if (socialAds.length || socialAdsG.length) {
    dynamicGroups.push({
      title: 'Social Ads',
      key: 'socialAds',
      items: [...socialAds, ...socialAdsG],
      requires: extractRequires([...socialAds, ...socialAdsG]),
      type: 'group',
      section: 'apps',
      mutuallyExclusiveWith: [],
      subGroup: 'socialAds',
    })
  }

  if (mc2Items.length) {
    dynamicGroups.push({
      title: 'Thryv Growth Platform',
      key: 'thryvgrowthplatform',
      items: mc2Items,
      requires: [],
      type: 'group',
      section: 'centers',
      subGroup: null,
    })
  }

  otherItems.forEach(i =>
    dynamicGroups.push({
      title: i.name,
      key: i.code,
      items: [i],
      requires: extractRequires([i]),
      type: 'single',
      section:
        i.section === 'centers' || i.name.toLowerCase().includes('center')
          ? 'centers'
          : 'apps',
    }),
  )

  console.log('dynamicGroups -->', dynamicGroups)

  return [defaultEmailValidationCard, onetimeFeesCard, ...dynamicGroups]
}

const cartGroupsToCartCentersAndApps = cartGroups => {
  const safeGroups = Array.isArray(cartGroups) ? cartGroups : []

  const centersAndApps = safeGroups.reduce(
    (acc, group) => {
      switch (group.section) {
        case 'centers':
          acc.centers.push(...(group.items || []))
          break
        case 'apps':
          acc.apps.push(...(group.items || []))
          break
        case 'onetimeFees':
          acc.onetimeFees.push(...(group.items || []))
          break
        default:
          break
      }
      return acc
    },
    {centers: [], apps: [], onetimeFees: []},
  )

  return centersAndApps
}

// const mergeSocialAndGrowthIntoThryvAddons = centersAndApps => {
//   if (!centersAndApps) return centersAndApps

//   const {apps = []} = centersAndApps
//   const THRYV_ADDONS_CODE = 'appmarket-5-thryv-m2m'
//   const GROWTH_PACKAGE_CODES = ['addon-5-mcstartgr', 'addon-5-mcexpangr']

//   // Identify groups
//   const thryvAddons = apps.find(a => a.code === THRYV_ADDONS_CODE)
//   const socialAds = apps.filter(a => a.code?.startsWith('addon-socialads'))
//   const growthPackages = apps.filter(a => GROWTH_PACKAGE_CODES.includes(a.code))

//   const allNewAddons = [...socialAds, ...growthPackages]
//   if (allNewAddons.length === 0) return centersAndApps

//   // Merge into existing Thryv Add-Ons if found
//   if (thryvAddons) {
//     const existingAddons = thryvAddons.addons || thryvAddons.entitlements || []
//     const existingCodes = existingAddons.map(a => a.code)
//     const merged = [
//       ...existingAddons,
//       ...allNewAddons.filter(a => !existingCodes.includes(a.code)),
//     ]
//     thryvAddons.addons = merged
//   } else {
//     // Use default base structure from thryvAddonsList
//     const baseAddons = thryvAddonsList?.[0]
//     const baseEntitlements = baseAddons?.entitlements || []
//     const existingCodes = baseEntitlements.map(e => e.code)

//     const merged = [
//       ...baseEntitlements,
//       ...allNewAddons.filter(a => !existingCodes.includes(a.code)),
//     ]

//     apps.push({
//       ...baseAddons,
//       addons: merged,
//       entitlements: undefined,
//     })
//   }

//   // Remove Social Ads and Growth Packages from main app list
//   centersAndApps.apps = apps.filter(
//     a =>
//       !a.code?.startsWith('addon-socialads') &&
//       !GROWTH_PACKAGE_CODES.includes(a.code),
//   )

//   return centersAndApps
// }

// const cartGroupsToCartCentersAndApps = (
//   cartGroups,
//   allGroupCustomFieldsMap = {},
// ) => {
//   const safeGroups = Array.isArray(cartGroups) ? cartGroups : []

//   const centersAndApps = safeGroups.reduce(
//     (acc, group) => {
//       const {section, key, items = []} = group

//       // Assign customFields from map if present for this group
//       const customFieldsForGroup = allGroupCustomFieldsMap[key] || {}

//       // const enrichedItems = items.map(item => ({
//       //   ...item,
//       //   customFields: customFieldsForGroup, // attach from map
//       // }))
//       const enrichedItems = items.map(item => {
//         if (item?.groupKey === 'seo') {
//           return {
//             ...item,
//             customFields: customFieldsForGroup,
//             // addons: customFieldsForGroup?.addons, // only add when groupKey === 'seo'
//           }
//         } else {
//           return {
//             ...item,
//             customFields: customFieldsForGroup,
//           }
//         }
//       })

//       switch (section) {
//         case 'centers':
//           acc.centers.push(...enrichedItems)
//           break
//         case 'apps':
//           acc.apps.push(...enrichedItems)
//           break
//         case 'oneTimeFees':
//           acc.oneTimeFees.push(...enrichedItems)
//           break
//         default:
//           break
//       }

//       return acc
//     },
//     {centers: [], apps: [], oneTimeFees: []},
//   )

//   // Handle thryv addons group - growth package and Social Ads
//   const finalCentersAndApps =
//     mergeSocialAndGrowthIntoThryvAddons(centersAndApps)

//   return finalCentersAndApps
// }

const extractCustomFieldsMap = (groups = []) => {
  return groups.reduce((acc, group) => {
    const itemWithCustomFields = group.items?.find(
      item => item.customFields && Object.keys(item.customFields).length > 0,
    )

    if (itemWithCustomFields) {
      let customFields = itemWithCustomFields.customFields
      if (itemWithCustomFields?.code === 'seobase-5-thryv-m2m') {
        customFields = {
          ...customFields,
          addons: [...(itemWithCustomFields.addons || [])],
        }
      }
      acc[group.key] = customFields
    }

    return acc
  }, {})
}

const syncCatalogWithDefaultCart = (catalogGroups, defaultCartGroups) => {
  // Create a map for quick lookup: defaultCart[groupKey][itemCode] = item
  const defaultMap = {}
  if (defaultCartGroups && defaultCartGroups?.length > 0) {
    defaultCartGroups.forEach(group => {
      group.items.forEach(item => {
        if (!defaultMap[group.key]) defaultMap[group.key] = {}
        defaultMap[group.key][item.code] = item
        // Map addons separately for entitlements comparison
        if (item.addons && item.addons.length) {
          item.addons.forEach(addon => {
            defaultMap[group.key][addon.code] = addon
          })
        }
      })
    })
  }

  return catalogGroups.map(group => {
    const defaultItemsMap = defaultMap[group.key] || {}

    const updatedItems = group.items.map(item => {
      const defaultItem = defaultItemsMap[item.code]

      // Update item.isAlreadyAdded if the default cart item exists and is already added
      const updatedItem =
        defaultItem && defaultItem.isAlreadyAdded
          ? {...item, isAlreadyAdded: true}
          : item

      // Update entitlements' isAlreadyAdded based on matching default cart addons
      const updatedEntitlements =
        updatedItem.entitlements?.map(entitlement => {
          const matchingAddon = defaultItemsMap[entitlement.code]
          if (matchingAddon && matchingAddon.isAlreadyAdded) {
            return {...entitlement, isAlreadyAdded: true}
          }
          return entitlement
        }) || []

      return {
        ...updatedItem,
        entitlements: updatedEntitlements,
      }
    })

    return {
      ...group,
      items: updatedItems,
    }
  })
}

const mergeCartGroups = (placeholder = [], defaultGroups = []) => {
  // Clone placeholder to avoid direct mutation
  const merged = JSON.parse(JSON.stringify(placeholder))

  if (defaultGroups && defaultGroups?.length > 0) {
    defaultGroups?.forEach(defaultGroup => {
      const existingGroup = merged.find(g => g.key === defaultGroup.key)

      if (existingGroup) {
        // Replace items safely
        existingGroup.items = [...(defaultGroup.items || [])]

        // Optionally update other group-level properties (if needed)
        Object.keys(defaultGroup).forEach(key => {
          if (key !== 'items') {
            existingGroup[key] = defaultGroup[key]
          }
        })
      } else {
        // Add missing group
        merged.push(defaultGroup)
      }
    })
  }

  return merged
}

const useKPDefaultSubList = (
  run,
  client,
  user,
  thryvId,
  selectedCountry = 'US',
) => {
  const [centersNAppVList, setCentersNAppVList] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const linkType = useSelector(selectedLinkType)
  // const {actualRole, } = useSelector(selectUserRoles)
  const userRoles = useSelector(selectEffectiveRole)
  const userFeatures = useUserFeatures()

  const isInfluencerOps =
    Array.isArray(userRoles) && userRoles.includes('InfluencerOps')

  const isKeapPartner =
    Array.isArray(userRoles) && userRoles.includes('KeapPartner')
  console.log('useKPDefault', {isInfluencerOps, isKeapPartner})
  // const user = useAuth0()
  // const userRoles = getUserRoles(user)
  // console.log('useKPDefault:', {user})
  useEffect(() => {
    async function fetchKeapDefaultSubList() {
      try {
        // let res = await run(client('keappartner/v2List'))
        // if (res?.data) {
        //   setCentersNAppVList(res.data)
        // } else {
        //   setCentersNAppVList({})
        // }
        // console.log({userRoles})
        const baseAppType = linkType === '1:many' ? 'kp1tomany' : 'kp1to1'

        let res
        if (isInfluencerOps && linkType !== '1:many') {
          //show keap plans for influencers in 1:1 flow
          const [baseCatalogRes, influencerRes] = await Promise.all([
            client(
              `plans/5/v1/list?country=${encodeURIComponent(selectedCountry)}`,
              {
                headers: {'app-type': baseAppType},
              },
            ),
            client(
              `plans/5/v1/list?country=${encodeURIComponent(selectedCountry)}`,
              {
                headers: {'app-type': 'influencerops'},
              },
            ),
          ])
          const influencerKeapCenters = (influencerRes?.centers || []).filter(
            c => c.uigroup === 'Keap',
          )
          res = {
            ...baseCatalogRes,
            centers: [
              ...(baseCatalogRes?.centers || []).filter(
                c => c.uigroup !== 'Keap',
              ),
              ...influencerKeapCenters,
            ],
          }
        } else {
          res = await client(
            `plans/5/v1/list?country=${encodeURIComponent(selectedCountry)}`,
            {
              headers: {
                'app-type': isInfluencerOps ? 'influencerops' : baseAppType,
              },
            },
          )
        }
        if (res) {
          setCentersNAppVList(applyProductRulesBeforeLoading(res, userFeatures))
        } else {
          setCentersNAppVList({})
        }
      } catch (err) {
        console.error('Error fetching keap default sub list:', err)
        toast.error('Error fetching keap default sub list:', err)
        setError(err)
        setCentersNAppVList({})
      } finally {
        setLoading(false)
      }
    }
    fetchKeapDefaultSubList()
  }, [client, isInfluencerOps, linkType, run, selectedCountry])
  return {centersNAppVList, loading, error}
}
const useKeapPartnerDetails = (run, client, user) => {
  const [keapPartnerDetails, setKeapPartnerDetails] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true)
      try {
        const resp = await kP11LinkService.fetchKeapPartnerUserDetails(
          run,
          client,
          user,
        )
        setKeapPartnerDetails(resp)
      } catch (err) {
        console.error('Error fetching KP user details:', err)
        toast.error('Error fetching KP user details:', err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }
    fetchDetails()
  }, [run, client, user])
  return {keapPartnerDetails, loading, error}
}
const useAccountInformation = (run, client, user, locationState = {}) => {
  const [accountInfo, setAccountInfo] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const {isUpgrade} = locationState || {}
  useEffect(() => {
    // If no upgrade, just set from locationState
    if (!isUpgrade) {
      setAccountInfo(locationState)
      return
    }
    // Otherwise, fetch and merge
    const fetchAccountInfo = async () => {
      setLoading(true)
      try {
        const resp = await kP11LinkService.fetchAccountInformationByEmail(
          run,
          client,
          locationState?.email || '',
          locationState?.accountCode || null,
        )
        setAccountInfo({
          ...resp,
          ...locationState,
        })
      } catch (err) {
        console.error('Error fetching account information:', err)
        toast.error('Error fetching account information:', err)
        setError(err)
        // Fallback to location state if API fails
        setAccountInfo(locationState)
      } finally {
        setLoading(false)
      }
    }
    fetchAccountInfo()
  }, [isUpgrade, run, client, user, locationState])
  return {accountInfoWithSub: accountInfo, loading, error}
}

export const useKP11LinkData = () => {
  const dispatch = useDispatch()
  const client = useAuthClient()
  const {run} = useAsync({status: 'pending'})
  const {user} = useAuth0()
  const {state: locationState = {}} = useLocation()
  const selectedCountry = locationState?.selectedCountry || 'US'
  const userFeatures = useUserFeatures()
  const isCountryEnabled = useMemo(() => {
    const flagMap = {
      US: Boolean(userFeatures?.MC_Free_Trial),
      AU: Boolean(userFeatures?.MC_AU),
      NZ: Boolean(userFeatures?.MC_NZ),
    }
    return flagMap[selectedCountry] ?? false
  }, [userFeatures, selectedCountry])
  const [thryvAccount, setThryvAccount] = useState({})
  const [catalogGroups, setCatalogGroups] = useState([])
  const [cartGroups, setCartGroups] = useState([])
  const [defaultCartGroups, setDefaultCartGroups] = useState([])
  const [allGroupCustomFieldsMap, setAllGroupCustomFieldsMap] = useState({})
  const [defaultAllGroupCustomFieldsMap, setDefaultAllGroupCustomFieldsMap] =
    useState({})
  const useThryvAccountData = (run, client, user, thryvId) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    useEffect(() => {
      if (!thryvId) return // only run if we have a valid thryvId
      console.log('inside fetch subscription by thryv id')
      const fetchThryvData = async () => {
        setLoading(true)
        try {
          const response = await kP11LinkService.fetchSubscriptionByThryvId(
            run,
            client,
            thryvId,
            true,
          )
          setThryvAccount(response)
        } catch (err) {
          console.error('Error fetching Thryv account data:', err)
          toast.error('Error fetching Thryv account data:', err)
          setError(err)
        } finally {
          setLoading(false)
        }
      }
      fetchThryvData()
    }, [run, client, user, thryvId])
    useEffect(() => {
      if (!thryvAccount || Object.keys(thryvAccount).length === 0) return
    }, [thryvAccount])
    return {thryvAccount, loading, error}
  }
  // API hooks
  const {
    centersNAppVList,
    loading: kpSublistLoading,
    error: kpSublistError,
  } = useKPDefaultSubList(run, client, user, undefined, selectedCountry)
  const {
    keapPartnerDetails,
    loading: partnerLoading,
    error: partnerError,
  } = useKeapPartnerDetails(run, client, user)
  const {
    accountInfoWithSub,
    loading: accountLoading,
    error: accountError,
  } = useAccountInformation(run, client, user, locationState)
  const thryvAccountId = useMemo(
    () =>
      accountInfoWithSub?.thryvId ||
      accountInfoWithSub?.accountCode ||
      accountInfoWithSub?.thryvDetail?.thryvId ||
      null,
    [accountInfoWithSub],
  )
  const {loading: thryvLoading, error: thryvError} = useThryvAccountData(
    run,
    client,
    user,
    thryvAccountId,
  )
  // -------------------- Initialize groups --------------------
  //////////////////////////////////////////////////////////////
  useEffect(() => {
    if (!centersNAppVList) {
      setCatalogGroups([])
      setCartGroups([])
      return
    }
    const filteredCentersNAppVList = filterCentersAndAppsByCountry(
      centersNAppVList,
      selectedCountry,
    )
    // Then pass filtered data to buildCenterAndAppsGroups
    const targetCurrency = countryCurrencyEnum[selectedCountry]
    const builtCatalogGroups = buildCenterAndAppsGroups(
      filteredCentersNAppVList,
      'catalog',
      ['rc-5-thryv-m2m'],
      [],
      targetCurrency,
      isCountryEnabled,
    )
    const parseKeapTierOption = option => {
      const [qtyRaw, amountRaw = ''] = String(option?.value || '').split('-')
      const qty = Number(qtyRaw)
      const amount = Number(String(amountRaw).replace(/,/g, ''))
      if (!Number.isFinite(qty) || !Number.isFinite(amount)) return null
      return {...option, qty, amount}
    }
    const resolveKeapTierOption = (options = [], addon = null) => {
      if (!addon || !Array.isArray(options) || options.length === 0) return null
      const parsedOptions = options.map(parseKeapTierOption).filter(Boolean)
      if (parsedOptions.length === 0) return null

      const unitAmount = Number(addon.unitAmount)
      const subtotal = Number(addon.subtotal)
      const candidates = [unitAmount, subtotal].filter(Number.isFinite)
      const exactMatchTolerance = 0.2

      for (const candidate of candidates) {
        const exactMatch = parsedOptions.find(
          option =>
            Math.abs(Number(option.amount) - Number(candidate)) <=
            exactMatchTolerance,
        )
        if (exactMatch) return exactMatch
      }

      const baseAmount = Number.isFinite(subtotal) ? subtotal : unitAmount
      if (!Number.isFinite(baseAmount) || baseAmount <= 0) return null

      const nearest = parsedOptions.reduce((best, option) => {
        const distance = Math.abs(option.amount - baseAmount)
        if (!best || distance < best.distance) {
          return {...option, distance}
        }
        return best
      }, null)

      if (!nearest) return null
      const relativeDistance = nearest.distance / baseAmount
      return relativeDistance <= 0.12 ? nearest : null
    }
    const getCustomFieldValue = (customFields, fieldNames = []) => {
      if (!customFields || !fieldNames?.length) return null

      if (Array.isArray(customFields)) {
        const lowerCaseFieldNames = fieldNames.map(field => field.toLowerCase())
        const field = customFields.find(item =>
          lowerCaseFieldNames.includes(String(item?.name || '').toLowerCase()),
        )
        return field?.value ?? null
      }

      if (typeof customFields === 'object') {
        for (const name of fieldNames) {
          if (customFields[name] !== undefined && customFields[name] !== null) {
            return customFields[name]
          }
        }
      }

      return null
    }
    //initialize select and default cart
    if (thryvAccount?.accountInfo?.email) {
      const COMMAND_CENTER_NAME_MAPPING = {
        'cc_basic-5-thryv-m2m': 'My Account',
        'cc_basicpls-5-thryv-m2m': 'My Account',
        'cc_plus-5-thryv-m2m': 'My Account Plus',
        'cc_pro-5-thryv-m2m': 'My Account Pro',
      }
      let ADDITIONAL_CONTACT_OPTIONS =
        selectedCountry === 'US'
          ? [
              {name: 'Up To 1,000 Contacts: $36', value: '1000-36'},
              {name: 'Up To 2,500 Contacts: $84', value: '2500-84'},
              {name: 'Up To 5,000 Contacts: $150', value: '5000-150'},
              {name: 'Up To 10,000 Contacts: $240', value: '10000-240'},
              {name: 'Up To 15,000 Contacts: $330', value: '15000-330'},
              {name: 'Up To 25,000 Contacts: $420', value: '25000-420'},
              {name: 'Up To 50,000 Contacts: $480', value: '50000-480'},
              {name: 'Up To 75,000 Contacts: $600', value: '75000-600'},
              {name: 'Up To 100,000 Contacts: $720', value: '100000-720'},
              {
                name: 'Up To 200,000 Contacts: $1,200',
                value: '200000-1200',
              },
              {
                name: 'Up To 500,000 Contacts: $1,980',
                value: '500000-1980',
              },
              {
                name: 'Up To 750,000 Contacts: $2,940',
                value: '750000-2940',
              },
              {
                name: 'Up To 1,000,000 Contacts: $3,720',
                value: '1000000-3720',
              },
              {
                name: 'Up To 2,000,000 Contacts: $5,940',
                value: '2000000-5940',
              },
              {
                name: 'Up To 3,000,000 Contacts: $7,200',
                value: '3000000-7200',
              },
              {
                name: 'Up To 4,000,000 Contacts: $8,460',
                value: '4000000-8460',
              },
              {
                name: 'Over 4,000,000 Contacts: $10,140',
                value: '5000000-10140',
              },
            ]
          : selectedCountry === 'AU'
          ? [
              {
                name: 'Up To 1,000 Contacts: AU $46.20 w/GST',
                value: '1000-46.20',
              },
              {
                name: 'Up To 2,500 Contacts: AU $107.80 w/GST',
                value: '2500-107.80',
              },
              {
                name: 'Up To 5,000 Contacts: AU $195.80 w/GST',
                value: '5000-195.80',
              },
              {
                name: 'Up To 10,000 Contacts: AU $310.20 w/GST',
                value: '10000-310.20',
              },
              {
                name: 'Up To 15,000 Contacts: AU $427.90 w/GST',
                value: '15000-427.90',
              },
              {
                name: 'Up To 25,000 Contacts: AU $545.60 w/GST',
                value: '25000-545.60',
              },
              {
                name: 'Up To 50,000 Contacts: AU $622.60 w/GST',
                value: '50000-622.60',
              },
              {
                name: 'Up To 75,000 Contacts: AU $777.70 w/GST',
                value: '75000-777.70',
              },
              {
                name: 'Up To 100,000 Contacts: AU $935.00 w/GST',
                value: '100000-935.00',
              },
              {
                name: 'Up To 200,000 Contacts: AU $1,556.50 w/GST',
                value: '200000-1556.50',
              },
              {
                name: 'Up To 500,000 Contacts: AU $2,050.40 w/GST',
                value: '500000-2050.40',
              },
              {
                name: 'Up To 750,000 Contacts: AU $3,803.80 w/GST',
                value: '750000-3803.80',
              },
              {
                name: 'Up To 1,000,000 Contacts: AU $4,813.60 w/GST',
                value: '1000000-4813.60',
              },
              {
                name: 'Up To 2,000,000 Contacts: AU $7,687.90 w/GST',
                value: '2000000-7687.90',
              },
              {
                name: 'Up To 3,000,000 Contacts: AU $9,318.10 w/GST',
                value: '3000000-9318.10',
              },
              {
                name: 'Up To 4,000,000 Contacts: AU $10,948.30 w/GST',
                value: '4000000-10948.30',
              },
              {
                name: 'Over 4,000,000 Contacts: AU $13,121.90 w/GST',
                value: '4000000-13121.90',
              },
            ]
          : selectedCountry === 'NZ'
          ? [
              {name: 'Up To 1,000 Contacts: $60.00', value: '1000-60.00'},
              {
                name: 'Up To 2,500 Contacts: $140.00',
                value: '2500-140.00',
              },
              {
                name: 'Up To 5,000 Contacts: $250.00',
                value: '5000-250.00',
              },
              {
                name: 'Up To 10,000 Contacts: $400.00',
                value: '10000-400.00',
              },
              {
                name: 'Up To 15,000 Contacts: $550.00',
                value: '15000-550.00',
              },
              {
                name: 'Up To 25,000 Contacts: $700.00',
                value: '25000-700.00',
              },
              {
                name: 'Up To 50,000 Contacts: $800.00',
                value: '50000-800.00',
              },
              {
                name: 'Up To 75,000 Contacts: $1,000.00',
                value: '75000-1000.00',
              },
              {
                name: 'Up To 100,000 Contacts: $1,200.00',
                value: '100000-1200.00',
              },
              {
                name: 'Up To 200,000 Contacts: $2,000.00',
                value: '200000-2000.00',
              },
              {
                name: 'Up To 500,000 Contacts: $3,300.00',
                value: '500000-3300.00',
              },
              {
                name: 'Up To 750,000 Contacts: $4,900.00',
                value: '750000-4900.00',
              },
              {
                name: 'Up To 1,000,000 Contacts: $6,200.00',
                value: '1000000-6200.00',
              },
              {
                name: 'Up To 2,000,000 Contacts: $9,900.00',
                value: '2000000-9900.00',
              },
              {
                name: 'Up To 3,000,000 Contacts: $12,000.00',
                value: '3000000-12000.00',
              },
              {
                name: 'Up To 4,000,000 Contacts: $14,100.00',
                value: '4000000-14100.00',
              },
              {
                name: 'Over 4,000,000 Contacts: $16,900.00',
                value: '4000000-16900.00',
              },
            ]
          : [
              {name: 'Up To 1,000 Contacts: $49', value: '1000-49'},
              {name: 'Up To 2,500 Contacts: $114', value: '2500-114'},
              {name: 'Up To 5,000 Contacts: $203', value: '5000-203'},
              {name: 'Up To 10,000 Contacts: $325', value: '10000-325'},
              {name: 'Up To 15,000 Contacts: $446', value: '15000-446'},
              {name: 'Up To 25,000 Contacts: $568', value: '25000-568'},
              {name: 'Up To 50,000 Contacts: $649', value: '50000-649'},
              {name: 'Up To 75,000 Contacts: $811', value: '75000-811'},
              {name: 'Up To 100,000 Contacts: $973', value: '100000-973'},
              {
                name: 'Up To 200,000 Contacts: $1,622',
                value: '200000-1622',
              },
              {
                name: 'Up To 500,000 Contacts: $2,676',
                value: '500000-2676',
              },
              {
                name: 'Up To 750,000 Contacts: $3,973',
                value: '750000-3973',
              },
              {
                name: 'Up To 1,000,000 Contacts: $5,027',
                value: '1000000-5027',
              },
              {
                name: 'Up To 2,000,000 Contacts: $8,027',
                value: '2000000-8027',
              },
              {
                name: 'Up To 3,000,000 Contacts: $9,730',
                value: '3000000-9730',
              },
              {
                name: 'Up To 4,000,000 Contacts: $11,433',
                value: '4000000-11433',
              },
              {
                name: 'Over 4,000,000 Contacts: $13,703',
                value: '4000000-13703',
              },
            ]
      let KEAP_TEXT_VOICE_OPTIONS =
        selectedCountry === 'US'
          ? [
              {name: 'Tier 1: $14', value: '1-14'},
              {name: 'Tier 2: $24', value: '2-24'},
              {name: 'Tier 3: $39', value: '3-39'},
              {name: 'Tier 4: $79', value: '4-79'},
              {name: 'Tier 5: $139', value: '5-139'},
              {name: 'Tier 6: $279', value: '6-279'},
            ]
          : selectedCountry === 'AU'
          ? [
              {name: 'Tier 1: AU $21 w/GST', value: '1-21'},
              {
                name: 'Tier 2: AU $39.60 w/GST',
                value: '2-39.60',
              },
              {
                name: 'Tier 3: AU $64.90 w/GST',
                value: '3-64.90',
              },
              {
                name: 'Tier 4: AU $130.90 w/GST',
                value: '4-130.90',
              },
              {name: 'Tier 5: AU $231 w/GST', value: '5-231'},
              {
                name: 'Tier 6: AU $463.10 w/GST',
                value: '6-463.10',
              },
            ]
          : selectedCountry === 'NZ'
          ? [
              {name: 'Tier 1: $23', value: '1-23'},
              {name: 'Tier 2: $40', value: '2-40'},
              {name: 'Tier 3: $65', value: '3-65'},
              {name: 'Tier 4: $132', value: '4-132'},
              {name: 'Tier 5: $232', value: '5-232'},
              {name: 'Tier 6: $465', value: '6-465'},
            ]
          : [
              {name: 'Tier 1: $19', value: '1-19'},
              {name: 'Tier 2: $33', value: '2-33'},
              {name: 'Tier 3: $53', value: '3-53'},
              {name: 'Tier 4: $107', value: '4-107'},
              {name: 'Tier 5: $188', value: '5-188'},
              {name: 'Tier 6: $377', value: '6-377'},
            ]
      const getAccountCentersAndApps = allSubscriptions => {
        const STARTER_PACKAGE_ADDON_CODES = [
          'addon-5-mcstartgr',
          'addon-5-mcexpangr',
        ]
        let centersAndApps = {centers: [], apps: []}
        let thryvMaxAddonprods = centersNAppVList.apps
          ?.filter(
            app =>
              KEAP_ADDONS_PARENT_CODES.includes(app.parentProduct) &&
              !KEAP_ADDONS_PARENT_CODES.includes(app.code),
          )
          .map(item => item.code)

        allSubscriptions.forEach(subscription => {
          let found = false

          if (subscription?.code.includes('-legacy-')) {
            let subCode = subscription.code
            let entitlements = []
            let type = ''
            if (subCode.includes('addon-')) {
              type = 'apps'
            } else if (subCode.includes('-ot')) {
              type = 'oneTimeFees'
            } else {
              type = 'centers'
              entitlements = subscription.addons
            }
            const formattedData = {
              code: subscription.code,
              name: subscription.name,
              id: subscription.code,
              entitlements: entitlements,
              amount: subscription.total,
              uuid: subscription.uuid,
              unitAmount: subscription.unitAmount,
              quantity: subscription.quantity,
              createdAt: subscription.createdAt,
              addons: subscription.addons,
              groupTitle: 'hidden',
              //img: commandCenterIconV1,
              isAlreadyAdded: true,
            }
            switch (type) {
              case 'centers': {
                centersAndApps.centers.push(formattedData)
                break
              }
              case 'apps': {
                centersAndApps.apps.push(formattedData)
                break
              }
              case 'oneTimeFees': {
                centersAndApps.onetimeFees.push(formattedData)
                break
              }
              default:
                console.log('none got triggered')
            }
            console.log({formatedData: formattedData, type, centersAndApps})

            found = true
          } else if (subscription?.code.startsWith('cc_')) {
            const entitlements = (subscription?.addons || []).map(addon => {
              return {
                ...addon,
                amount:
                  addon.unitAmount && addon.quantity
                    ? addon.unitAmount * addon.quantity
                    : 0,
                isAlreadyAdded: true,
              }
            })
            const formattedCenter = {
              code: subscription.code,
              name: COMMAND_CENTER_NAME_MAPPING[subscription.code],
              id: subscription.code,
              entitlements: entitlements,
              amount: subscription.total,
              uuid: subscription.uuid,
              unitAmount: subscription.unitAmount,
              quantity: subscription.quantity,
              createdAt: subscription.createdAt,
              addons: subscription.addons,
              groupTitle: 'Command Center',
              //img: commandCenterIconV1,
              isAlreadyAdded: true,
            }
            centersAndApps.centers.push(formattedCenter)
            found = true
          } else {
            for (const center of centersNAppVList.centers) {
              if (subscription.code === center.code) {
                let isGrowthPackageInCart = subscription.addons?.some(
                  ({code}) => STARTER_PACKAGE_ADDON_CODES.includes(code),
                )
                const entitlements =
                  subscription.code === 'seobase-5-thryv-m2m'
                    ? []
                    : (subscription?.addons || []).map(addon => {
                        const excludes = center.entitlements.find(
                          ({code}) => code === addon.code,
                        )?.excludes
                        return {
                          ...addon,
                          amount:
                            addon.unitAmount && addon.quantity
                              ? addon.unitAmount * addon.quantity
                              : 0,
                          isAlreadyAdded: true,
                          excludes,
                        }
                      })
                const formattedCenter = {
                  ...center,
                  entitlements,
                  groupTitle: subscription.groupTitle,
                  uuid: subscription.uuid,
                  unitAmount: subscription.unitAmount,
                  quantity: subscription.quantity,
                  createdAt: subscription.createdAt,
                  isAlreadyAdded: true,
                }
                const isSEOorLeads =
                  (subscription.code.includes('seo') &&
                    subscription.code !== 'seobase-5-thryv-m2m') ||
                  subscription.name === 'Thryv Leads'
                if (isSEOorLeads) {
                  formattedCenter.amount = subscription.quantity
                }
                if (subscription.code === 'seobase-5-thryv-m2m') {
                  formattedCenter.amount = subscription.quantity
                  formattedCenter.quantity = 1
                }
                // Include custom fields if any exist
                if (
                  subscription?.customFields &&
                  Object.keys(subscription?.customFields).length > 0
                ) {
                  let cFields = {}
                  if (
                    subscription.code === 'mc_pro-5-thryv-m2m' ||
                    subscription.code === 'mc_plus-5-thryv-m2m'
                  ) {
                    const customFields = subscription.customFields
                    cFields = {
                      mcDomain: customFields?.Domain,
                    }
                    formattedCenter.customFields = cFields
                  }
                  if (subscription.code === 'seobase-5-thryv-m2m') {
                    const customFields = subscription.customFields
                    cFields = {
                      alphaProposalId: customFields?.SEO_Proposal_ID,
                      alphaDomain: customFields?.Domain,
                    }
                    formattedCenter.customFields = cFields
                  }
                  if (subscription.code === 'tl-mc-5-thryv-m2m') {
                    const customFields = subscription.customFields
                    cFields = {
                      thryvLeadAmount: customFields?.ThryvLeads_Quantity,
                      thryvLeadsId: customFields?.ThryvLeads_Campaign_ID,
                    }
                    formattedCenter.customFields = cFields
                  }
                }
                if (isGrowthPackageInCart) {
                  const growthPackageAddOn = subscription.addons?.find(
                    ({code}) =>
                      code === 'addon-5-mcstartgr' ||
                      code === 'addon-5-mcexpangr',
                  )
                  growthPackageAddOn.amount = growthPackageAddOn.unitAmount
                  centersAndApps.apps.push(growthPackageAddOn)
                }
                centersAndApps.centers.push(formattedCenter)
                found = true
                break
              }
            }
            if (!found) {
              for (const app of centersNAppVList.apps) {
                if (subscription.code === app.code) {
                  centersAndApps.apps.push({
                    ...app,
                    uuid: subscription.uuid,
                    unitAmount: subscription.unitAmount,
                    groupTitle: subscription.groupTitle,
                    quantity: subscription.quantity,
                    isAlreadyAdded: true,
                  })
                  found = true
                  break
                }
              }
            }
            if (!found) {
              subscription['isAlreadyAdded'] = true
              if (
                subscription.code === 'addon-5-seokey-m2m' ||
                subscription.code === 'addon-5-seopb-m2m' ||
                subscription.code === 'addon-6-seats-m2m'
              ) {
                // subscription['alreadyIncluded'] = true
                subscription['groupTitle'] = 'Thryv Add-Ons'
                subscription.amount = subscription.unitAmount
              } else {
                if (
                  subscription.code === 'appmarket-5-thryv-m2m' ||
                  subscription.code === 'addon-5-signatures_usage' ||
                  subscription.code === 'app-websitebuilder' ||
                  thryvMaxAddonprods?.includes(subscription.code)
                ) {
                  // subscription['alreadyIncluded'] = true
                  if (
                    subscription.code === 'addon-5-signatures_usage' ||
                    subscription.code === 'app-websitebuilder'
                  ) {
                    subscription['groupTitle'] = 'Thryv Add-Ons'
                  }
                  if (thryvMaxAddonprods?.includes(subscription.code)) {
                    subscription['groupTitle'] = 'Thryv Add-Ons'
                  }
                }
                subscription.amount = subscription.unitAmount
                  ? subscription.subtotal
                  : 0
                if (subscription?.addons) {
                  subscription.addons = []
                }
              }

              centersAndApps.apps.push(subscription)
            }
          }
        })
        //social ads bronze
        let socialAdsBronzeAddOn = allSubscriptions.find(sub =>
          sub.code.includes('addon-socialadsbronze-5-m2m'),
        )
        if (socialAdsBronzeAddOn) {
          dispatch(setSocialAdsBronzeQuantity(socialAdsBronzeAddOn?.quantity))
        }
        //social ads silver
        let socialAdsSilverAddOn = allSubscriptions.find(sub =>
          sub.code.includes('addon-socialadssilver-5-m2m'),
        )
        if (socialAdsSilverAddOn) {
          dispatch(setSocialAdsSilverQuantity(socialAdsSilverAddOn?.quantity))
        }
        //social ads gold
        let socialAdsGoldAddOn = allSubscriptions.find(sub =>
          sub.code.includes('addon-socialadsgold-5-m2m'),
        )
        if (socialAdsGoldAddOn) {
          dispatch(setSocialAdsGoldQuantity(socialAdsGoldAddOn?.quantity))
        }
        //keap AddOns
        let KeapAddOns = allSubscriptions.find(sub =>
          KEAP_ADDONS_PARENT_CODES.includes(sub.code),
        )
        if (KeapAddOns) {
          let keapAdditionalContacts = KeapAddOns?.addons?.find(
            addon => addon.code === 'addon-5-keap-addcontacts-m2m',
          )
          if (keapAdditionalContacts) {
            const matchedAddContactOption = resolveKeapTierOption(
              ADDITIONAL_CONTACT_OPTIONS,
              keapAdditionalContacts,
            )
            if (matchedAddContactOption) {
              //setKeapAddContactsRecurlyQty(matchedAddContactOption.qty)
              dispatch(
                setKeapAddContactsQuantity(
                  parseFloat(matchedAddContactOption.qty),
                ),
              )
              //setKeapTextVoiceRecurlyQty(matchedKeapTextVoiceOption.qty)
              dispatch(
                setSelectedKeapAddContactsOption(matchedAddContactOption.value),
              )
            }
          }
          let keapTextVoice = KeapAddOns?.addons?.find(
            addon => addon.code === 'addon-5-keap-textvoice-m2m',
          )
          if (keapTextVoice) {
            const matchedKeapTextVoiceOption = resolveKeapTierOption(
              KEAP_TEXT_VOICE_OPTIONS,
              keapTextVoice,
            )
            if (matchedKeapTextVoiceOption) {
              dispatch(
                setKeapTextVoiceQuantity(
                  parseFloat(matchedKeapTextVoiceOption.qty),
                ),
              )
              //setKeapTextVoiceRecurlyQty(matchedKeapTextVoiceOption.qty)
              dispatch(
                setSelectedKeapTextVoiceOption(
                  matchedKeapTextVoiceOption.value,
                ),
              )
            }
          }
          let KeapAddUsers = KeapAddOns?.addons?.find(
            addon => addon.code === 'addon-5-keap-addusers-m2m',
          )
          if (KeapAddUsers) {
            dispatch(
              setKeapAddUsersQuantity(Number(KeapAddUsers.quantity) || 0),
            )
          }
        }
        centersAndApps = {...centersAndApps, oneTimeFees: []}

        const alphaSEO = allSubscriptions.find(
          sub => sub.code === 'seobase-5-thryv-m2m',
        )
        if (alphaSEO) {
          const alphaProposalId =
            alphaSEO.alphaProposalId ||
            getCustomFieldValue(alphaSEO.customFields, ['SEO_Proposal_ID']) ||
            ''
          const alphaDomain =
            alphaSEO.alphaDomain ||
            getCustomFieldValue(alphaSEO.customFields, ['Domain']) ||
            ''
          const alphaExternalDomainValue =
            alphaSEO.isExternalDomain ??
            alphaSEO.externalDomain ??
            getCustomFieldValue(alphaSEO.customFields, [
              'isExternalDomain',
              'Is_External_Domain',
              'externalDomain',
            ]) ??
            null
          const normalizedExternalDomainValue =
            typeof alphaExternalDomainValue === 'string'
              ? alphaExternalDomainValue.toLowerCase()
              : alphaExternalDomainValue
          let normalizedExternalDomain =
            normalizedExternalDomainValue === true ||
            normalizedExternalDomainValue === 'yes'
              ? 'yes'
              : normalizedExternalDomainValue === false ||
                normalizedExternalDomainValue === 'no'
              ? 'no'
              : null
          if (!normalizedExternalDomain && alphaSEO.state === 'future') {
            normalizedExternalDomain = 'no'
          }
          dispatch(
            setAlphaSEOFromRecurly({
              alphaProposalId,
              alphaDomain,
              isExternalDomain: normalizedExternalDomain,
              alphaAmount: alphaSEO.quantity,
              alphaIsExternalDomain: normalizedExternalDomain,
            }),
          )
          dispatch(
            setAlphaKeyCount(
              (alphaSEO?.addons || []).filter(
                addon => addon.code === 'addon-5-seokey-m2m',
              ).length > 0
                ? (alphaSEO?.addons || []).filter(
                    addon => addon.code === 'addon-5-seokey-m2m',
                  )[0].quantity
                : 0,
            ),
          )
          dispatch(
            setAlphaPowerBoostCount(
              (alphaSEO?.addons || []).filter(
                addon => addon.code === 'addon-5-seopb-m2m',
              ).length > 0
                ? (alphaSEO?.addons || []).filter(
                    addon => addon.code === 'addon-5-seopb-m2m',
                  )[0].quantity
                : 0,
            ),
          )
        }
        dispatch(
          setThryvSubscriptionData({
            response: thryvAccount,
            processedData: centersAndApps,
          }),
        )
        return centersAndApps
      }
      const appMarketplace = thryvAccount?.childSubscriptions.find(
        ({code}) => code === 'appmarket-5-thryv-m2m',
      )
      const alphSEOProd = thryvAccount?.childSubscriptions.find(
        ({code}) => code === 'seobase-5-thryv-m2m',
      )
      const thryvMaxAddons = thryvAccount?.childSubscriptions.find(({code}) =>
        KEAP_ADDONS_PARENT_CODES.includes(code),
      )
      let allSubscriptions = [
        ...(Array.isArray(thryvAccount?.childSubscriptions)
          ? thryvAccount.childSubscriptions
          : []),
        ...(Array.isArray(thryvAccount?.parentSubscriptions)
          ? thryvAccount.parentSubscriptions
          : []),
        ...(appMarketplace?.addons || []),
      ]

      if (alphSEOProd) {
        allSubscriptions = [...allSubscriptions, ...(alphSEOProd?.addons || [])]
      }
      if (thryvMaxAddons) {
        allSubscriptions = [
          ...allSubscriptions,
          ...(thryvMaxAddons?.addons || []),
        ]
      }
      getAccountCentersAndApps(allSubscriptions)
    } else {
      //reset to default cart
      dispatch(resetToDefaultCart())
    }
    console.log('builtCatalogGroups', builtCatalogGroups)
    // sync Catalog group With DefaultCartgroup to check if any item is already added
    const updatedCatalogGroups = syncCatalogWithDefaultCart(
      builtCatalogGroups,
      {},
    )

    const placeholder = updatedCatalogGroups.map(({items, ...rest}) => ({
      ...rest,
      items: [], // start empty
    }))

    // Merge any default selected items into cart placeholder
    const updatedCartGroups = mergeCartGroups(placeholder, {})
    const customFields = extractCustomFieldsMap(updatedCartGroups)

    setCatalogGroups(updatedCatalogGroups)
    setDefaultCartGroups([...updatedCartGroups])
    setCartGroups([...updatedCartGroups])
    setDefaultAllGroupCustomFieldsMap(customFields)
    setAllGroupCustomFieldsMap(customFields)

    // Initialize Redux store with cart data
    dispatch(
      initializeKP11Cart({
        cartGroups: updatedCartGroups,
        catalogGroups: updatedCatalogGroups,
        allGroupCustomFieldsMap: customFields,
        centersNAppVList: filteredCentersNAppVList,
        defaultCartGroups: updatedCartGroups,
        defaultAllGroupCustomFieldsMap: customFields,
        selectedCountry,
      }),
    )
  }, [
    centersNAppVList,
    dispatch,
    selectedCountry,
    thryvAccount,
    isCountryEnabled,
  ])

  //////////////////////////////////
  //////////////////////////////////

  // -------------------------
  // Structured cart always reflects current cart state
  // -------------------------
  const cartCentersAndApps = useMemo(() => {
    return cartGroupsToCartCentersAndApps(cartGroups, allGroupCustomFieldsMap)
  }, [cartGroups, allGroupCustomFieldsMap])

  const isLoading =
    partnerLoading || accountLoading || thryvLoading || kpSublistLoading
  const hasError = partnerError || accountError || thryvError || kpSublistError
  // -------------------------
  // Coupons / promotions
  // -------------------------
  const {
    allCoupons,
    plansIncentiveGroups,
    removeCoupon,
    togglePlanIncentive,
    fetchAndApplyPromoCode,
  } = KP11LinkUseCoupons(client, locationState, selectedCountry, thryvAccount)
  return {
    isLoading,
    hasError,
    selectedCountry,
    locationState,
    keapPartnerDetails,
    accountInfoWithSub,
    thryvAccount,
    centersNAppVList,
    defaultCartGroups,
    cartGroups,
    setCartGroups,
    catalogGroups,
    setCatalogGroups,
    allGroupCustomFieldsMap,
    setAllGroupCustomFieldsMap,
    defaultAllGroupCustomFieldsMap,
    cartCentersAndApps,
    allCoupons,
    plansIncentiveGroups,
    removeCoupon,
    togglePlanIncentive,
    fetchAndApplyPromoCode,
  }
}
//////////////////////////////////////
//#endregion
//////////////////////////////////////

//////////////////////////////////////
//#region -- Utility Functions/usehooks to transform final data for generate link, send link, order creation etc...
//////////////////////////////////////
const transformCartData = (
  cartCentersAndApps,
  selectedCentersNApps = {centers: [], apps: [], oneTimeFees: []},
) => {
  const transformItem = (item, type) => {
    const base = {
      type,
      name: item.name,
      code: item.code,
      unitAmount: item.unitAmount,
      // amount: item.amount,
      quantity: item.quantity,
      currency: 'USD',
      addons: [],
    }
    // Include custom fields if any exist
    if (item.customFields && Object.keys(item.customFields).length > 0) {
      let cFields = {}
      if (
        item.code === 'mc_pro-5-thryv-m2m' ||
        item.code === 'mc_plus-5-thryv-m2m'
      ) {
        // const {alphaAmount, alphaDomain, alphaProposalId} = item.customFields
        const customFields = item.customFields
        cFields = {
          mcDomain: customFields.mcDomain,
        }
      }
      if (item.code === 'maxhvac-5-thryv-m2m') {
        const customFields = item.customFields
        cFields = {
          homeServicesPaymentOption: customFields.paymentOption,
        }
      }
      if (item.code === 'seobase-5-thryv-m2m') {
        // const {alphaAmount, alphaDomain, alphaProposalId} = item.customFields
        const customFields = item.customFields
        cFields = {
          alphaProposalId: customFields.alphaProposalId,
          alphaAmount: customFields?.alphaAmount,
          alphaDomain: customFields.alphaDomain,
          isExternalDomain: customFields.isExternalDomain,
        }
      }
      if (item.code === 'tl-mc-5-thryv-m2m') {
        // const {billingDate, budget, proposalId} = item.customFields
        const customFields = item.customFields
        cFields = {
          futureBillingDate: customFields.futureBillingDate,
          thryvLeadAmount: customFields.thryvLeadAmount || item?.subtotal,
          thryvLeadsId: customFields.thryvLeadsId,
        }
      }
      base.customFields = cFields
    }
    // Add only non-included entitlements
    if (item.addons?.length > 0) {
      base.addons = item.addons
        .filter(ent => !ent.included)
        .map(ent => ({
          unitAmount: ent.unitAmount,
          quantity: ent.quantity ?? 1,
          name: ent.name,
          code: ent.code,
          isAlreadyAdded: true,
        }))
    }
    return base
  }
  // Helper to avoid duplicates by `code`
  const mergeUnique = (existing = [], incoming = []) => {
    const existingCodes = new Set(existing.map(i => i.code))
    const newItems = incoming.filter(i => !existingCodes.has(i.code))
    // return [...existing, ...newItems]
    return [...newItems, ...existing]
  }
  // Transform only non-included items
  const transformedCenters = (cartCentersAndApps.centers || [])
    .filter(c => !c.isAlreadyAdded && !c.isUpgraded)
    .map(c => transformItem(c, 'centers'))
  const transformedApps = (cartCentersAndApps.apps || [])
    .filter(a => !a.isAlreadyAdded && !a.isUpgraded)
    .map(a => transformItem(a, 'app'))
  const transformedOneTimeFees = (cartCentersAndApps.oneTimeFees || [])
    .filter(f => !f.isAlreadyAdded && !f.isUpgraded)
    .map(f => transformItem(f, 'oneTimeFee'))
  // Merge with existing without duplicates
  const mergedCenters = mergeUnique(
    selectedCentersNApps.centers,
    transformedCenters,
  )
  const mergedApps = mergeUnique(selectedCentersNApps.apps, transformedApps)
  const mergedOneTimeFees = mergeUnique(
    selectedCentersNApps.oneTimeFees,
    transformedOneTimeFees,
  )
  return {
    centers: mergedCenters,
    apps: mergedApps,
    oneTimeFees: mergedOneTimeFees,
  }
}
// // const cartChecksForAppointmentsAndNewItem = (
// //   alreadyAddedCart,
// //   cartCentersAndApps,
// // ) => {
// //   if (!alreadyAddedCart)
// //     alreadyAddedCart = {centers: [], apps: [], oneTimeFees: []}
// //   const TARGET_CODES = ['seobase-5-thryv-m2m', 'tl-mc-5-thryv-m2m']
// //   const DESIGN_CODE = ['thryvdesg2']
// //   // Helper: find item or addon by code and check isAlreadyAdded
// //   const hasCode = (arr = [], codes = []) => {
// //     if (!Array.isArray(arr) || !Array.isArray(codes)) return false

// //     return arr.some(item => {
// //       const codeMatch = codes.includes(item.code) && !!item.isAlreadyAdded
// //       const addonMatch = item.addons?.length
// //         ? hasCode(item.addons, codes)
// //         : false
// //       return codeMatch || addonMatch
// //     })
// //   }
// //   const hasNewCodeInCart = (arr = []) =>
// //     arr.some(item => {
// //       const isNewItem = !item.isAlreadyAdded // means not yet added
// //       // Check recursively for new addons
// //       const hasNewAddons =
// //         Array.isArray(item.addons) && item.addons.length > 0
// //           ? hasNewCodeInCart(item.addons)
// //           : false
// //       return isNewItem || hasNewAddons
// //     })
// //   // Check in main cart (centers, apps)
// //   const hasSeoOrTlInAlreadyAddedCart =
// //     hasCode(alreadyAddedCart.centers, TARGET_CODES) ||
// //     hasCode(alreadyAddedCart.apps, TARGET_CODES)
// //   // Check in structured cart (centers, apps)
// //   const hasSeoOrTlInCartCentersAndApps =
// //     hasCode(cartCentersAndApps.centers, TARGET_CODES) ||
// //     hasCode(cartCentersAndApps.apps, TARGET_CODES)
// //   // Check thryvdesg2 in main cart (centers, apps, oneTimeFees)
// //   const hasThryvDesg2AlreadyAddedCart =
// //     hasCode(alreadyAddedCart.centers, DESIGN_CODE) ||
// //     hasCode(alreadyAddedCart.apps, DESIGN_CODE) ||
// //     hasCode(alreadyAddedCart.oneTimeFees, DESIGN_CODE)
// //   // Check thryvdesg2 in cartCentersAndApps cart (centers, apps, oneTimeFees)
// //   const hasThryvDesg2CartCentersAndApps =
// //     hasCode(cartCentersAndApps.centers, DESIGN_CODE) ||
// //     hasCode(cartCentersAndApps.apps, DESIGN_CODE) ||
// //     hasCode(cartCentersAndApps.oneTimeFees, DESIGN_CODE)
// //   // Check new item in cartCentersAndApps cart (centers, apps, oneTimeFees)
// //   const isNewItemInCartCentersAndApps =
// //     hasNewCodeInCart(cartCentersAndApps.centers) ||
// //     hasNewCodeInCart(cartCentersAndApps.apps) ||
// //     hasNewCodeInCart(cartCentersAndApps.oneTimeFees)
// //   // Consolidated check results
// //   return {
// //     hasSeoOrTlInAlreadyAddedCart,
// //     hasSeoOrTlInCartCentersAndApps,
// //     hasThryvDesg2AlreadyAddedCart,
// //     hasThryvDesg2CartCentersAndApps,
// //     isNewItemInCartCentersAndApps,
// //     // anySeoOrTl: hasSeoOrTlInCart || hasSeoOrTlInStructured, // overall check
// //   }
// // }
// const cartChecksForAppointmentsAndNewItem = (
//   alreadyAddedCart,
//   cartCentersAndApps,
// ) => {
//   // Default empty cart
//   if (!alreadyAddedCart)
//     alreadyAddedCart = {centers: [], apps: [], oneTimeFees: []}
//   if (!cartCentersAndApps)
//     cartCentersAndApps = {centers: [], apps: [], oneTimeFees: []}

//   const TARGET_CODES = ['seobase-5-thryv-m2m', 'tl-mc-5-thryv-m2m']
//   const DESIGN_CODE = ['thryvdesg2']

//   // ----------------------------
//   // Helper: check for items with matching code AND isAlreadyAdded === true
//   const hasCodeAlreadyAdded = (arr = [], codes = []) => {
//     if (!Array.isArray(arr) || !Array.isArray(codes)) return false
//     return arr.some(item => {
//       const codeMatch = codes.includes(item.code) && !!item.isAlreadyAdded
//       const addonMatch = item.addons?.length
//         ? hasCodeAlreadyAdded(item.addons, codes)
//         : false
//       return codeMatch || addonMatch
//     })
//   }

//   // Helper: check for items with matching code, ignore isAlreadyAdded
//   const hasCodeAny = (arr = [], codes = []) => {
//     if (!Array.isArray(arr) || !Array.isArray(codes)) return false
//     return arr.some(item => {
//       const codeMatch = codes.includes(item.code)
//       const addonMatch = item.addons?.length
//         ? hasCodeAny(item.addons, codes)
//         : false
//       return codeMatch || addonMatch
//     })
//   }

//   // Helper: check for new items (isAlreadyAdded false or undefined)
//   const hasNewItem = (arr = []) =>
//     arr.some(item => {
//       const isNew = item.isAlreadyAdded !== true // false or undefined counts as new
//       const hasNewAddon = item.addons?.length ? hasNewItem(item.addons) : false
//       return isNew || hasNewAddon
//     })

//   // ----------------------------
//   // Flags
//   const hasSeoOrTlInAlreadyAddedCart =
//     hasCodeAlreadyAdded(alreadyAddedCart.centers, TARGET_CODES) ||
//     hasCodeAlreadyAdded(alreadyAddedCart.apps, TARGET_CODES)

//   const hasSeoOrTlInCartCentersAndApps =
//     hasCodeAlreadyAdded(cartCentersAndApps.centers, TARGET_CODES) ||
//     hasCodeAlreadyAdded(cartCentersAndApps.apps, TARGET_CODES)

//   const hasThryvDesg2AlreadyAddedCart =
//     hasCodeAny(alreadyAddedCart.centers, DESIGN_CODE) ||
//     hasCodeAny(alreadyAddedCart.apps, DESIGN_CODE) ||
//     hasCodeAny(alreadyAddedCart.oneTimeFees, DESIGN_CODE)

//   const hasThryvDesg2CartCentersAndApps =
//     hasCodeAny(cartCentersAndApps.centers, DESIGN_CODE) ||
//     hasCodeAny(cartCentersAndApps.apps, DESIGN_CODE) ||
//     hasCodeAny(cartCentersAndApps.oneTimeFees, DESIGN_CODE)

//   const isNewItemInCartCentersAndApps =
//     hasNewItem(cartCentersAndApps.centers) ||
//     hasNewItem(cartCentersAndApps.apps) ||
//     hasNewItem(cartCentersAndApps.oneTimeFees)

//   // ----------------------------
//   return {
//     hasSeoOrTlInAlreadyAddedCart,
//     hasSeoOrTlInCartCentersAndApps,
//     hasThryvDesg2AlreadyAddedCart,
//     hasThryvDesg2CartCentersAndApps,
//     isNewItemInCartCentersAndApps,
//   }
// }

// const cartChecksForAppointmentsAndNewItem = (
//   alreadyAddedCart,
//   cartCentersAndApps,
// ) => {
//   // Default empty cart
//   if (!alreadyAddedCart)
//     alreadyAddedCart = {centers: [], apps: [], oneTimeFees: []}
//   if (!cartCentersAndApps)
//     cartCentersAndApps = {centers: [], apps: [], oneTimeFees: []}

//   const TARGET_CODES = ['seobase-5-thryv-m2m', 'tl-mc-5-thryv-m2m']
//   const DESIGN_CODE = ['thryvdesg2']

//   // ----------------------------
//   // Helper: check for items with matching code AND isAlreadyAdded === true
//   const hasCodeAlreadyAdded = (arr = [], codes = []) => {
//     if (!Array.isArray(arr) || !Array.isArray(codes)) return false
//     return arr.some(item => {
//       const codeMatch = codes.includes(item.code) && !!item.isAlreadyAdded
//       const addonMatch = item.addons?.length
//         ? hasCodeAlreadyAdded(item.addons, codes)
//         : false
//       return codeMatch || addonMatch
//     })
//   }

//   // Helper: check for items with matching code (ignore isAlreadyAdded)
//   const hasCodeAny = (arr = [], codes = []) => {
//     if (!Array.isArray(arr) || !Array.isArray(codes)) return false
//     return arr.some(item => {
//       const codeMatch = codes.includes(item.code)
//       const addonMatch = item.addons?.length
//         ? hasCodeAny(item.addons, codes)
//         : false
//       return codeMatch || addonMatch
//     })
//   }

//   // Helper: check for new items (isAlreadyAdded false or undefined)
//   const hasNewItem = (arr = []) =>
//     arr.some(item => {
//       const isNew = item.isAlreadyAdded !== true // false or undefined counts as new
//       const hasNewAddon = item.addons?.length ? hasNewItem(item.addons) : false
//       return isNew || hasNewAddon
//     })

//   // ----------------------------
//   // Existing five flags
//   const hasSeoOrTlInAlreadyAddedCart =
//     hasCodeAlreadyAdded(alreadyAddedCart.centers, TARGET_CODES) ||
//     hasCodeAlreadyAdded(alreadyAddedCart.apps, TARGET_CODES)

//   const hasSeoOrTlInCartCentersAndApps =
//     hasCodeAlreadyAdded(cartCentersAndApps.centers, TARGET_CODES) ||
//     hasCodeAlreadyAdded(cartCentersAndApps.apps, TARGET_CODES)

//   const hasThryvDesg2AlreadyAddedCart =
//     hasCodeAny(alreadyAddedCart.centers, DESIGN_CODE) ||
//     hasCodeAny(alreadyAddedCart.apps, DESIGN_CODE) ||
//     hasCodeAny(alreadyAddedCart.oneTimeFees, DESIGN_CODE)

//   const hasThryvDesg2CartCentersAndApps =
//     hasCodeAny(cartCentersAndApps.centers, DESIGN_CODE) ||
//     hasCodeAny(cartCentersAndApps.apps, DESIGN_CODE) ||
//     hasCodeAny(cartCentersAndApps.oneTimeFees, DESIGN_CODE)

//   const isNewItemInCartCentersAndApps =
//     hasNewItem(cartCentersAndApps.centers) ||
//     hasNewItem(cartCentersAndApps.apps) ||
//     hasNewItem(cartCentersAndApps.oneTimeFees)

//   // ----------------------------
//   // Button enable flags: only enable if item is newly added (isAlreadyAdded !== true)
//   const isKickOffApptHasSeoOrTlInCart =
//     (cartCentersAndApps.centers || []).some(
//       item => TARGET_CODES.includes(item.code) && item.isAlreadyAdded !== true,
//     ) ||
//     (cartCentersAndApps.apps || []).some(
//       item => TARGET_CODES.includes(item.code) && item.isAlreadyAdded !== true,
//     )

//   const isCreativeApptHasThryvDesg2InCart =
//     (cartCentersAndApps.centers || []).some(
//       item => DESIGN_CODE.includes(item.code) && item.isAlreadyAdded !== true,
//     ) ||
//     (cartCentersAndApps.apps || []).some(
//       item => DESIGN_CODE.includes(item.code) && item.isAlreadyAdded !== true,
//     ) ||
//     (cartCentersAndApps.oneTimeFees || []).some(
//       item => DESIGN_CODE.includes(item.code) && item.isAlreadyAdded !== true,
//     )

//   // ----------------------------
//   return {
//     hasSeoOrTlInAlreadyAddedCart,
//     hasSeoOrTlInCartCentersAndApps,
//     hasThryvDesg2AlreadyAddedCart,
//     hasThryvDesg2CartCentersAndApps,
//     isNewItemInCartCentersAndApps,
//     isKickOffApptHasSeoOrTlInCart,
//     isCreativeApptHasThryvDesg2InCart,
//   }
// }

const cartChecksForAppointmentsAndNewItem = cartCentersAndApps => {
  if (!cartCentersAndApps)
    cartCentersAndApps = {centers: [], apps: [], oneTimeFees: []}

  const TARGET_CODES = [
    'seobase-5-thryv-m2m',
    'tl-mc-5-thryv-m2m',
    'addon-socialadsbronze-5-m2m',
    'addon-socialadsgold-5-m2m',
    'addon-socialadssilver-5-m2m',
    'addon-6-mc-socialcontentgen-m2m',

    'wc_plus-5-thryv-m2m',
  ]
  // Add Social Content Gen addon to require Kickoff Call

  const DESIGN_CODE = ['thryvdesg2', 'addon-5-website_difm', 'thryv5page']

  // Combine all items into one array for easier checking
  const allCartItems = [
    ...(cartCentersAndApps.centers || []),
    ...(cartCentersAndApps.apps || []),
    ...(cartCentersAndApps.oneTimeFees || []),
  ]

  // ----------------------------
  // Helper: check if any item with matching codes is already added
  const hasAlreadyAddedItem = (arr = [], codes = []) =>
    arr.some(item => {
      const isAdded = codes.includes(item.code) && item.isAlreadyAdded === true
      const addonHasAdded = item.addons?.length
        ? hasAlreadyAddedItem(item.addons, codes)
        : false
      return isAdded || addonHasAdded
    })

  // Helper: check if any new item with matching codes exists
  const hasNewItem = (arr = [], codes = []) =>
    arr.some(item => {
      const isNew = codes.includes(item.code) && item.isAlreadyAdded !== true
      const addonHasNew = item.addons?.length
        ? hasNewItem(item.addons, codes)
        : false
      return isNew || addonHasNew
    })

  const hasNewOrUpgradedItem = (arr = [], codes = []) =>
    arr.some(item => {
      const isNewOrUpgraded =
        codes.includes(item.code) &&
        (item.isAlreadyAdded !== true || item.isUpgraded === true)
      const addonHasNewOrUpgraded = item.addons?.length
        ? hasNewOrUpgradedItem(item.addons, codes)
        : false
      return isNewOrUpgraded || addonHasNewOrUpgraded
    })

  // Helper: check if ALL items are new (none already added)
  const areAllItemsNew = (arr = []) =>
    arr.every(item => {
      const isNew = item.isAlreadyAdded !== true
      const addonsAllNew = item.addons?.length
        ? areAllItemsNew(item.addons)
        : true
      return isNew && addonsAllNew
    })

  const isAnyNewItem = (arr = []) =>
    arr.some(item => {
      const isNew = item.isAlreadyAdded !== true
      console.log(item.code, 'isNew:', isNew)
      const addonHasNew = item.addons?.length
        ? isAnyNewItem(item.addons)
        : false
      return isNew || addonHasNew
    })

  const isAnyUpgradedItem = (arr = []) =>
    arr.some(item => {
      const isUpgraded = item.isUpgraded === true
      console.log(item.code, 'isUpgraded:', isUpgraded)
      const addonHasUpgraded = item.addons?.length
        ? isAnyUpgradedItem(item.addons)
        : false
      return isUpgraded || addonHasUpgraded
    })

  // ----------------------------
  // Main flags
  const hasSeoOrTlInAlreadyAddedCart = hasAlreadyAddedItem(
    allCartItems,
    TARGET_CODES,
  )
  const hasThryvDesg2AlreadyAddedCart = hasAlreadyAddedItem(
    allCartItems,
    DESIGN_CODE,
  )

  const hasSeoOrTlInCartCentersAndApps = hasNewOrUpgradedItem(
    allCartItems,
    TARGET_CODES,
  )
  const hasThryvDesg2CartCentersAndApps = hasNewItem(allCartItems, DESIGN_CODE)

  const allNewItemInCartCentersAndApps = areAllItemsNew(allCartItems)
  const anyNewItemInCartCentersAndApps = isAnyNewItem(allCartItems)
  const anyUpgradedItemInCartCentersAndApps = isAnyUpgradedItem(allCartItems)

  // isTL or seo in cart
  const TL_SEO_PRODUCT = [
    ...(cartCentersAndApps?.centers?.filter(item =>
      ['tl-mc-5-thryv-m2m', 'seobase-5-thryv-m2m'].includes(item.code),
    ) || []),
    ...(cartCentersAndApps?.apps?.filter(item =>
      ['tl-mc-5-thryv-m2m', 'seobase-5-thryv-m2m'].includes(item.code),
    ) || []),
  ]
  let isSeoOrTLCallRequired =
    TL_SEO_PRODUCT?.length > 0
      ? TL_SEO_PRODUCT?.some(
          item => !item.isAlreadyAdded || item.isUpgraded === true,
        )
      : false
  // check socialAdsProduct
  let socialAdsProduct =
    cartCentersAndApps?.apps?.filter(item =>
      item.code?.includes('socialads'),
    ) || []
  let isSocialAdsRequiresCall =
    socialAdsProduct?.length > 0
      ? socialAdsProduct.every(
          item => !item.isAlreadyAdded || item.isUpgraded === true,
        )
      : false
  //check Thryv Social Posts
  const SOCIAL_POST_CODE = ['addon-6-mc-socialcontentgen-m2m']
  const isSocialPostsRequiresCall = hasNewOrUpgradedItem(
    allCartItems,
    SOCIAL_POST_CODE,
  )
  // ----------------------------
  // MC 2.0 (Thryv Growth Platform) onboarding call requirements
  const FALLBACK_PLAN_CODES = [
    'mc_prov2-5-thryv-m2m',
    'signature-5-thryv-annual',
  ]
  const SIGNATURE_PLUS_CODES = [
    'signature_plus-5-thryv-m2m',
    'signature_plus-5-thryv-annual',
  ]
  // signature_plus always requires a scheduling call (Professionally Designed Website)
  const hasNewSignaturePlusInCart = hasNewOrUpgradedItem(
    allCartItems,
    SIGNATURE_PLUS_CODES,
  )
  // fallback plans require a scheduling call only when the user chose includeOnboarding = 'Yes'
  const hasFallbackWithOnboarding = allCartItems.some(item => {
    if (!FALLBACK_PLAN_CODES.includes(item.code)) return false
    if (item.isAlreadyAdded === true) return false
    const onboardingValue =
      item.customFields?.includeOnboarding?.value ??
      item.customFields?.includeOnboarding
    return onboardingValue === 'Yes'
  })
  const isMC2OnboardingCallRequired =
    hasNewSignaturePlusInCart || hasFallbackWithOnboarding

  // ----------------------------
  // Appointment enable flags: enable only if new item exists AND no already added
  const isKickOffApptHasSeoOrTlInCart =
    (hasSeoOrTlInCartCentersAndApps && !hasSeoOrTlInAlreadyAddedCart) ||
    isSeoOrTLCallRequired ||
    isSocialAdsRequiresCall ||
    isSocialPostsRequiresCall ||
    (hasThryvDesg2CartCentersAndApps && !hasThryvDesg2AlreadyAddedCart) ||
    isMC2OnboardingCallRequired
  const isCreativeApptHasThryvDesg2InCart = false

  // ----------------------------
  return {
    hasSeoOrTlInAlreadyAddedCart,
    hasSeoOrTlInCartCentersAndApps,
    hasThryvDesg2AlreadyAddedCart,
    hasThryvDesg2CartCentersAndApps,
    allNewItemInCartCentersAndApps,
    anyNewItemInCartCentersAndApps,
    anyUpgradedItemInCartCentersAndApps,
    isKickOffApptHasSeoOrTlInCart,
    isCreativeApptHasThryvDesg2InCart,
  }
}

const fetchTransitionDataDetails = ({
  // alreadyAddedCartCentersNApps,
  defaultCartCentersNApps,
  cartCentersAndApps,
  accountInfoWithSub,
  keapPartnerDetails,
  allCoupons,
  scheduleKickOffCallDetails,
  scheduleCreativeCallDetails,
  keapPartnerId,
  linkType,
  bundleId,
}) => {
  const couponList = [
    ...(allCoupons?.defaultObFeeCoupon || []),
    ...(allCoupons?.promotions || []),
  ]
  const defaultIncentive = allCoupons?.plansIncentive || []
  let EID = ''
  let CCID = ''
  let email = ''
  let accountInformation = {}
  let centers = []
  let apps = []
  let selectedCentersNApps = {
    centers: [],
    apps: [],
    oneTimeFees: [],
  }
  if (accountInfoWithSub?.isUpgrade) {
    const subDetails = accountInfoWithSub?.subDetails
    const routeAccountInfo = accountInfoWithSub?.accountInformation || {}
    const routeBusinessAddress = routeAccountInfo?.businessAddress || {}
    let {childSubscriptions, parentSubscriptions} = subDetails || {}
    console.log('childSubscriptions', childSubscriptions)
    console.log('parentSubscriptions', parentSubscriptions)
    EID = subDetails?.username || ''
    CCID = parentSubscriptions?.[0]?.account?.code || ''
    email = accountInfoWithSub?.email || routeAccountInfo?.email || ''
    // Account information
    const addressDetails = subDetails?.address
    accountInformation = {
      state:
        addressDetails?.region ||
        routeBusinessAddress?.state ||
        routeAccountInfo?.state ||
        '',
      address:
        addressDetails?.street1 ||
        routeBusinessAddress?.street ||
        routeAccountInfo?.address ||
        '',
      city:
        addressDetails?.city ||
        routeBusinessAddress?.city ||
        routeAccountInfo?.city ||
        '',
      firstName: subDetails?.firstName || routeAccountInfo?.firstName || '',
      lastName: subDetails?.lastName || routeAccountInfo?.lastName || '',
      mobile: addressDetails?.phone || routeAccountInfo?.mobile || '',
      email: email || '',
      company: subDetails?.company || routeAccountInfo?.company || '',
      locationName:
        routeAccountInfo?.locationName || subDetails?.locationName || '',
      postCode:
        addressDetails?.postalCode ||
        routeBusinessAddress?.postalCode ||
        routeAccountInfo?.postalCode ||
        routeAccountInfo?.postCode ||
        undefined,
      companyPhone:
        addressDetails?.phone ||
        routeBusinessAddress?.phone ||
        routeAccountInfo?.companyPhone ||
        routeAccountInfo?.phone ||
        '',
      phone:
        addressDetails?.phone ||
        routeBusinessAddress?.phone ||
        routeAccountInfo?.phone ||
        routeAccountInfo?.companyPhone ||
        '',
      country:
        addressDetails?.country ||
        routeBusinessAddress?.country ||
        accountInfoWithSub?.country ||
        routeAccountInfo?.country ||
        'US',
      billTo:
        subDetails?.billTo ||
        accountInfoWithSub?.billTo ||
        routeAccountInfo?.billTo ||
        '',
    }
    if (['AU', 'NZ'].includes(accountInformation.country)) {
      accountInformation['abn'] =
        addressDetails?.abn || subDetails?.vatNumber || ''
    }
    childSubscriptions?.map(item => {
      let addons = []
      if (item?.addOns.length > 0) {
        item?.addOns.map(addOnItem => {
          let addonDetail = {
            unitAmount: addOnItem.unitAmount || 0,
            quantity: addOnItem.quantity,
            name: addOnItem.addOn.name,
            code: addOnItem.addOn.code,
            isAlreadyAdded: true,
          }
          addons.push(addonDetail)
          return addOnItem
        })
      }
      let basicDetail = {
        name: item.plan.name,
        code: item.plan.code,
        unitAmount: item.unitAmount,
        quantity: item.quantity,
        isAlreadyAdded: true,
        currency: item.currency,
        // customFields: item?.customFields || [],
        addons,
      }
      if (item.plan.name.includes('SEO')) {
        let customFields = {}
        item.customFields.map(item => {
          if (item.name === 'SEO_Proposal_ID') {
            customFields['alphaProposalId'] = item.value
          }
          if (item.name === 'Domain') {
            customFields['alphaDomain'] = item.value
          }
          return item
        })
        basicDetail['customFields'] = {
          ...customFields,
          alphaAmount: item.total,
          isExternalDomain: false,
        }
      }
      if (item.plan.code.includes('tl-mc')) {
        let customFields = {}
        item.customFields.map(item => {
          if (item.name === 'ThryvLeads_Campaign_ID') {
            customFields['thryvLeadsId'] = item.value
          }
          if (item.name === 'ThryvLeads_Quantity') {
            customFields['thryvLeadAmount'] = item.value
          }
          return item
        })
        basicDetail = {...basicDetail, customFields: customFields}
      }
      if (
        item.plan.code.includes('mc_plus-5-thryv-m2m') ||
        item.plan.code.includes('mc_pro-5-thryv-m2m')
      ) {
        let customFields = {}
        item.customFields.map(item => {
          if (item.name === 'mcDomain') {
            customFields['mcDomain'] = item.value
          }
          return item
        })
        basicDetail = {...basicDetail, customFields: customFields}
      }
      if (
        item.plan.name.toLowerCase().includes('center') ||
        (item.plan.code.includes('legacy') && !item.plan.code.includes('addon'))
      ) {
        centers.push({
          ...basicDetail,
          type: 'center',
        })
      } else {
        apps.push({...basicDetail, type: 'app'})
      }
      return item
    })
    parentSubscriptions?.map(item => {
      let basicDetail = {
        name: item.plan.name,
        code: item.plan.code,
        unitAmount: item.unitAmount,
        quantity: item.quantity,
        isAlreadyAdded: true,
      }
      if (item.plan.name.toLowerCase().includes('center')) {
        centers.push({
          ...basicDetail,
          type: 'center',
        })
      } else {
        apps.push({...basicDetail, type: 'app'})
      }
      return item
    })
    selectedCentersNApps = {centers: centers, apps: apps, oneTimeFees: []}
  } else {
    const accInfo = accountInfoWithSub?.accountInformation
    const bussAddr = accInfo?.businessAddress
    accountInformation = {
      state: bussAddr?.state || accInfo?.state || '',
      address: bussAddr?.street || accInfo?.address || '',
      city: bussAddr?.city || accInfo?.city || '',
      firstName: accInfo?.firstName || '',
      lastName: accInfo?.lastName || '',
      mobile: accInfo?.mobile || '',
      email: accInfo?.email || '',
      company: accInfo?.company || '',
      locationName: accInfo?.locationName || '',
      postCode: bussAddr?.postalCode || accInfo?.postalCode || undefined,
      phone: bussAddr?.phone || accInfo?.phone || '',
      companyPhone: bussAddr?.phone || accInfo?.companyPhone || '',
      country:
        bussAddr?.country ||
        accountInfoWithSub?.country ||
        accInfo?.country ||
        'US',
      billTo: accInfo?.billTo || accountInfoWithSub?.billTo || '',
    }
    if (['AU', 'NZ'].includes(accountInformation.country)) {
      accountInformation['abn'] = accInfo?.abn || ''
    }
  }
  const cartCentersAndAppsWithKeapField =
    bundleId && cartCentersAndApps
      ? {
          ...cartCentersAndApps,
          apps: cartCentersAndApps.apps?.map(app => {
            if (
              app.code === 'addon-5-keap-addons' ||
              app.code?.startsWith('keap_')
            ) {
              return {
                ...app,
                customFields: {
                  ...(app.customFields || {}),
                  slp_share_link_id: bundleId,
                },
              }
            }
            return app
          }),
        }
      : cartCentersAndApps
  const formattedCentersNApps = transformCartData(
    cartCentersAndAppsWithKeapField,
    selectedCentersNApps,
  )
  console.log('formattedCentersNApps -- transition data', formattedCentersNApps)
  // const tempCartCodeDetails = [
  //   ...(formattedCentersNApps?.centers?.length
  //     ? formattedCentersNApps.centers.map(i => i.code)
  //     : []),
  //   ...(formattedCentersNApps?.apps?.length
  //     ? formattedCentersNApps.apps.map(i => i.code)
  //     : []),
  // ]
  const tempCartCodeDetails = [
    ...(cartCentersAndApps?.centers?.length
      ? cartCentersAndApps.centers.map(i => i.code)
      : []),
    ...(cartCentersAndApps?.apps?.length
      ? cartCentersAndApps.apps.map(i => i.code)
      : []),
  ]
  const {
    hasSeoOrTlInAlreadyAddedCart,
    hasSeoOrTlInCartCentersAndApps,
    hasThryvDesg2AlreadyAddedCart,
    hasThryvDesg2CartCentersAndApps,
    allNewItemInCartCentersAndApps,
    anyNewItemInCartCentersAndApps,
    anyUpgradedItemInCartCentersAndApps,
    isKickOffApptHasSeoOrTlInCart,
    isCreativeApptHasThryvDesg2InCart,
  } = cartChecksForAppointmentsAndNewItem(
    // alreadyAddedCartCentersNApps,
    // defaultCartCentersNApps,
    cartCentersAndApps,
  )
  // const isKickOffApptHasSeoOrTlInCart =
  //   !hasSeoOrTlInAlreadyAddedCart ||
  //   (!hasSeoOrTlInAlreadyAddedCart && hasSeoOrTlInCartCentersAndApps)
  // const isCreativeApptHasThryvDesg2InCart =
  //   !hasThryvDesg2AlreadyAddedCart ||
  //   (!hasThryvDesg2AlreadyAddedCart && hasThryvDesg2CartCentersAndApps)
  // const isKickOffApptHasSeoOrTlInCart =
  //   !hasSeoOrTlInAlreadyAddedCart && hasSeoOrTlInCartCentersAndApps

  // const isCreativeApptHasThryvDesg2InCart =
  //   !hasThryvDesg2AlreadyAddedCart && hasThryvDesg2CartCentersAndApps
  let kickOffCallDetails = isKickOffApptHasSeoOrTlInCart
    ? {
        isKickOffCallScheduled:
          scheduleKickOffCallDetails?.isCallScheduled || null,
        kickOffCallSchedule: scheduleKickOffCallDetails?.callDetails || {},
      }
    : {
        isKickOffCallScheduled: null,
        kickOffCallSchedule: {},
      }
  let creativeCallDetails = isCreativeApptHasThryvDesg2InCart
    ? {
        isCreativeCallScheduled:
          scheduleCreativeCallDetails?.isCallScheduled || null,
        creativeCallSchedule: scheduleCreativeCallDetails?.callDetails || {},
      }
    : {
        isCreativeCallScheduled: null,
        creativeCallSchedule: {},
      }
  // Return combined object
  let isCreativeAppt =
    linkType === '1:many' ? false : isCreativeApptHasThryvDesg2InCart
  return {
    // structuredCart,
    selectedCentersNApps: cartCentersAndAppsWithKeapField,
    cartDetails: tempCartCodeDetails,
    hasSeoOrTlInAlreadyAddedCart,
    hasSeoOrTlInCartCentersAndApps,
    hasThryvDesg2AlreadyAddedCart,
    hasThryvDesg2CartCentersAndApps,
    allNewItemInCartCentersAndApps,
    anyNewItemInCartCentersAndApps,
    anyUpgradedItemInCartCentersAndApps,
    isKickOffApptHasSeoOrTlInCart,
    isCreativeAppt,
    isCreativeApptHasThryvDesg2InCart,
    kickOffCallDetails,
    creativeCallDetails,
    linkType: {
      label: accountInfoWithSub?.linkType
        ? `${accountInfoWithSub.linkType} Link`
        : '',
    },
    partnerDetails: keapPartnerDetails?.user_metadata || {},
    thryvDetail: accountInfoWithSub?.isUpgrade ? accountInfoWithSub : {},
    ccId: CCID,
    EID: EID,
    email,
    accountInformation,
    couponList: couponList.length ? couponList : null,
    defaultIncentive: defaultIncentive.length ? defaultIncentive : null,
    keapPartnerId: keapPartnerId,
  }
}

export const useTransitionDataDetails = ({
  // alreadyAddedCartCentersNApps,
  defaultCartCentersNApps,
  cartCentersAndApps,
  accountInfoWithSub,
  keapPartnerDetails,
  allCoupons,
  scheduleKickOffCallDetails,
  scheduleCreativeCallDetails,
  keapPartnerId,
}) => {
  const [transitionData, setTransitionData] = useState(null)
  // const [isKickOffCallExist, setIsKickOffCallExist] = useState(false)
  // const [isCreativeCallExist, setIsCreativeCallExist] = useState(false)

  // Use refs to track previous values and prevent unnecessary updates
  const prevDepsRef = useRef()
  const linkType = useSelector(selectedLinkType)
  const bundleId = useSelector(state => state.user.bundleId)

  // Stringify dependencies for comparison to avoid object reference issues
  const depsString = JSON.stringify({
    defaultCartCentersNApps,
    cartCentersAndApps,
    accountInfoWithSub,
    keapPartnerDetails,
    allCoupons,
    scheduleKickOffCallDetails,
    scheduleCreativeCallDetails,
    keapPartnerId,
    bundleId,
    linkType,
  })

  useEffect(() => {
    if (!cartCentersAndApps) return

    // Only update if dependencies have actually changed
    if (prevDepsRef.current === depsString) return
    prevDepsRef.current = depsString

    const data = fetchTransitionDataDetails({
      // alreadyAddedCartCentersNApps,
      defaultCartCentersNApps,
      cartCentersAndApps,
      accountInfoWithSub,
      keapPartnerDetails,
      allCoupons,
      scheduleKickOffCallDetails,
      scheduleCreativeCallDetails,
      keapPartnerId,
      linkType,
      bundleId,
    })
    setTransitionData(data)
    // setIsKickOffCallExist(data.isSchedulerNeeded)
    // setIsCreativeCallExist(data.isCreativeCallNeeded)
  }, [
    depsString,
    cartCentersAndApps,
    defaultCartCentersNApps,
    accountInfoWithSub,
    keapPartnerDetails,
    allCoupons,
    scheduleKickOffCallDetails,
    scheduleCreativeCallDetails,
    keapPartnerId,
    bundleId,
    linkType,
  ])
  return {
    transitionData,
    // isKickOffCallExist,
    // isCreativeCallExist,
  }
}
//////////////////////////////////////
//#endregion
//////////////////////////////////////
